angular.module('gym.components').directive('memberDashlets', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/member_dashlets.html.slim'),
    scope: {
      contact: '=',
      currency: '&',
      setTab: '&'
    },
    controller: ["$scope", "$rootScope", "FeatureAvailabilityService", function($scope, $rootScope, FeatureAvailabilityService) {
      $scope.attendance = function() {
        return $scope.contact.attendance_dashlet;
      };
      $scope.balance = function() {
        return $scope.contact.balance_dashlet;
      };
      $scope.membership = function() {
        return $scope.contact.membership_dashlet;
      };
      return $scope.creditVouchersAvailable = FeatureAvailabilityService.isAvailable('credit_vouchers');
    }]
  };
});
